<div class="modal-main">
  <div class="close-modal">
    <button
      mat-icon-button
      aria-label="close modal"
      mat-dialog-close
      class="close-button"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (order) {
    <div class="modal-header-container">
      <h3>{{ order.fullName }}</h3>
    </div>
  }
  <div class="dialog-scroll-wrapper">
    @if (order) {
      <div class="order-root">
        <div class="col bold">
          <div>Type</div>
          <div>Event</div>
          <div>Date Of Use</div>
          <div>PWeek</div>
          <div>JFW Order #</div>
        </div>

        <div class="col">
          <div>
            {{ order.eventType || "N/A" }}
          </div>
          <div>
            {{ order.eventDescription || "N/A" }}
          </div>
          <div>
            {{ getFormattedDateWithWeekday(order.useDate) }}
          </div>
          <div>
            {{ getFormattedDateWithWeekday(order.productionWeek) }}
          </div>
          <div>
            {{ order.orderNumber || "N/A" }}
          </div>
        </div>
      </div>
      @if (unfulfilledItems.length) {
        <ng-container>
          <div class="delivery-container">
            <div>
              <span>Delivery Method: Unfulfilled</span>
            </div>
            <div class="modal-container">
              <!-- <div class="delivery-grid">
                <div class="col-1 bold">
                  <div>Ship Date</div>
                  <div>Packing Slip</div>
                </div>

                <div class="col-2">
                  <div>N/A</div>
                  <div>0</div>
                </div>
              </div> -->
              @if (showExtraColumn()){
                <div class="line-items-grid-extra-column">
                  <strong>Line</strong>
                  <strong>Item</strong>
                  <strong>Style</strong>
                  <strong>Size</strong>
                  <strong>Size</strong>
                  <strong>Quantity</strong>
                  <strong>Status</strong>
                  <strong>Scheduled Carrier</strong>
                  @for (item of unfulfilledItems; track item) {
                    <div>{{ item.line }}</div>
                    <div>{{ getStyleTypeFromCode(item.orderProduct) }}</div>
                    <div>{{ item.orderStyle }}</div>
                    <div>{{ item.orderOption1 }}</div>
                    <div>{{ item.orderOption2 }}</div>
                    <div>{{ item.quantity }}</div>
                    <div>{{ getLineItemStatus(item.orderStatus) }}</div>
                    <div>{{ getCarrierService(item.carrier, item.carrierService)}}</div>
                  }
                </div>
              } @else {
                <div class="line-items-grid">
                  <strong>Line</strong>
                  <strong>Item</strong>
                  <strong>Style</strong>
                  <strong>Size</strong>
                  <strong>Size</strong>
                  <strong>Quantity</strong>
                  <strong>Status</strong>
                  @for (item of unfulfilledItems; track item) {
                    <div>{{ item.line }}</div>
                    <div>{{ getStyleTypeFromCode(item.orderProduct) }}</div>
                    <div>{{ item.orderStyle }}</div>
                    <div>{{ item.orderOption1 }}</div>
                    <div>{{ item.orderOption2 }}</div>
                    <div>{{ item.quantity }}</div>
                    <div>{{ getLineItemStatus(item.orderStatus) }}</div>
                  }
                </div>
              }

            </div>
          </div>
        </ng-container>
      }

      @if (getFulfillments().length) {
        @for (fulfillment of getFulfillments(); track fulfillment) {
          <ng-container>
            <div class="modal-container">
              <div class="delivery-info">
                <span
                  >Delivery Method:
                  <span>{{ fulfillment.fulfillment }}</span>
                  @if (
                    fulfillment.carrier &&
                    fulfillment.carrier !== "" &&
                    fulfillment.packingSlipNumber !== undefined &&
                    fulfillment.packingSlipNumber !== 0
                  ) {
                    <span>
                      - {{ fulfillment.carrier }}
                      {{ fulfillment.carrierService }}</span
                    >
                  }
                </span>
                <div class="delivery-grid">
                  @if (fulfillment.fulfillment === FulfillmentTypes.Van) {
                    <div class="col-1 bold">
                      <div>Packing Slip</div>
                      <div>Depart Date</div>
                      <div>Arrive Date</div>
                    </div>
                    <div class="col-2">
                      <div>{{ fulfillment.packingSlipNumber || "N/A" }}</div>
                      <div>
                        {{
                          getFormattedDateWithWeekday(fulfillment.departDate)
                        }}
                      </div>
                      <div>
                        {{
                          getFormattedDateWithWeekday(fulfillment.arrivalDate)
                        }}
                      </div>
                    </div>
                  } @else if (
                    fulfillment.fulfillment === FulfillmentTypes.Parcel
                  ) {
                    <div class="col-1 bold">
                      <div>Packing Slip</div>
                      <div>Ship Date</div>
                    </div>
                    <div class="col-2">
                      <div>{{ fulfillment.packingSlipNumber || "N/A" }}</div>
                      @if (fulfillment.shipDate) {
                        <div>
                          {{
                            getFormattedDateWithWeekday(fulfillment.shipDate)
                          }}
                        </div>
                      } @else {
                        <div>N/A</div>
                      }
                    </div>
                  } @else {
                    <div class="col-1 bold">
                      <div>Packing Slip</div>
                    </div>
                    <div class="col-2">
                      <div>{{ fulfillment.packingSlipNumber || "N/A" }}</div>
                    </div>
                    <!-- Customer Pickup or Customer/Dealer Has In Possession -->
                  }
                </div>

                <div class="line-items-grid">
                  <strong>Line</strong>
                  <strong>Item</strong>
                  <strong>Style</strong>
                  <strong>Size</strong>
                  <strong>Size</strong>
                  <strong>Quantity</strong>
                  <strong>Status</strong>
                  @for (
                    item of getDetailsForFulfillment(fulfillment);
                    track item
                  ) {
                    <div>{{ item.line }}</div>
                    <div>{{ getStyleTypeFromCode(item.orderProduct) }}</div>
                    <div>{{ item.orderStyle }}</div>
                    <div>{{ item.orderOption1 }}</div>
                    <div>{{ item.orderOption2 }}</div>
                    <div>{{ item.quantity }}</div>
                    <div>{{ getLineItemStatus(item.orderStatus) }}</div>
                  }
                </div>
                @if (
                  fulfillment.fulfillment === "Parcel Delivery" &&
                  fulfillment.trackingNumber
                ) {
                  <div class="button-container">
                    <button
                      type="button"
                      mat-flat-button
                      style="min-width: 110px"
                      color="primary"
                      tabindex="-1"
                      (click)="openTracking(fulfillment.trackingNumber)"
                    >
                      Track
                    </button>
                    <p class="tracking-number">
                      {{ fulfillment.trackingNumber }}
                    </p>
                  </div>
                  @if (
                    fulfillment.fulfillment === "Parcel Delivery" &&
                    fulfillment.returnTrackingNumber !== undefined
                  ) {
                    <div class="return-button-container">
                      <button
                        type="button"
                        mat-flat-button
                        style="min-width: 110px"
                        color="primary"
                        tabindex="-1"
                        (click)="openTracking(fulfillment.returnTrackingNumber)"
                      >
                        Return Track
                      </button>
                      <p class="tracking-number">
                        {{ fulfillment.returnTrackingNumber }}
                      </p>
                    </div>
                  }
                } @else if (
                  fulfillment.fulfillment === "Parcel Delivery" &&
                  !fulfillment.trackingNumber
                ) {
                  <div class="button-container">Tracking Not Available</div>
                }
              </div>
            </div>
          </ng-container>
        }
      }
    } @else {
      <div style="position: relative; width: 100%">
        <div class="spinner-container-enabled">
          <mat-spinner></mat-spinner>
        </div>
      </div>
    }
  </div>
</div>
